/*
 * Title: GentleApi Obejct 
 * Author: KimTaeOh (taeoh.kim@gentlepie.com )
 * Date: 2021-04-03
 */

export default {
    type: {
        Bot: 'Bot',// '새로운 공지사항이 있는지 확인해보세요.',
        More: 'More',// '회원공지사항 더보기',
        Sales: 'Sales',// '품절/완판/재판매 공지',
        Service: 'Service',// '제휴서비스 공지',
        Product: 'Product', // '상품공지',
        Notice: 'Notice',   // 회원공지
        Next: 'Next',// '더 많은 공지사항 보기',
        Comment: 'Comment',// '최근 10건의 공지사항을 보여드릴게요.<br>더 많은 공지사항을 보려면 하단 버튼을 눌러주세요.',
        SalesMore: 'SalesMore',// '품절/완판/재판매 공지사항 더보기',
        ProductMore: 'ProductMore',// '상품 공지사항 더보기',
        ServiceMore: 'ServiceMore',
        NotFound: 'NotFound',
        FAQ: 'FAQ', //자주하는 질문 보기
    },
    tomy:{
        kr: {
            Bot: '새로운 공지사항이 있는지 자주 확인하시면 좋습니다.',
            More: '회원 공지사항 더보기',
            Sales: '품절/완판/재판매 공지사항 더 보기',
            Service: '제휴서비스 공지',
            Product: '상품공지',
            Notice: '회원공지',
            Next: '더 많은 공지사항 보기',
            Comment: '최근 공지사항 10건입니다. 아래 버튼을 누르면 더 많은 공지사항을 볼 수 있습니다.',
            SalesMore: '품절/완판/재판매 공지사항 더보기',
            ProductMore: '상품 공지사항 더보기',
            ServiceMore: '제휴서비스 공지사항 더보기',
            NotFound: '공지사항이 없습니다. 다른 회원들이 자주 하는 질문을 보시겠어요?',
            FAQ: '자주하는 질문 보기',
        },
        eng: {
            Bot: 'It is good to check back frequently for new announcements.',
            More: 'View more member notices',
            Sales: 'Out of stock/Sold out/Resale notices',
            Service: 'Affiliate service notices',
            Product: 'Product notices',
            Notice: 'Member notices',
            Next: 'See more announcements',
            Comment: 'There are 10 recent announcements. Click the button below to view more announcements.',
            SalesMore: 'See more notices for out of stock/sold out/resale',
            ProductMore: 'See more product announcements',
            ServiceMore: 'View more notices on affiliate service',
            NotFound: 'There are no announcements. Do you want to see frequently asked questions from other members? [View frequently asked questions]',
            FAQ: 'View frequently asked questions',

        }
    },
    papa:{
        kr: {
            Bot: '새로운 공지사항을 확인해보세요. 자주 체크하는 습관들 잘 들이고 있네요, 좋습니다!',
            More: '회원 공지사항 더보기',
            Sales: '품절/완판/재판매 공지',
            Service: '제휴서비스 공지',
            Product: '상품공지',
            Notice: '회원공지',
            Next: '더 많은 공지사항 보기',
            Comment: '최근 공지사항 10건입니다. 아래 버튼을 누르면 더 많은 공지사항을 볼 수 있습니다.',
            SalesMore: '품절/완판/재판매 공지사항 더보기',
            ProductMore: '상품 공지사항 더보기',
            ServiceMore: '제휴서비스 공지사항 더보기',
            NotFound: '아직 공지사항이 없네요. 아래 버튼을 누르면 다른 회원들이 자주하는 질문을 볼 수 있어요.',
            FAQ: '자주하는 질문 보기',

        },
        eng: {
            Bot: "Check out the new announcements. You're getting into the habit of checking frequently, good!",
            More: 'View more member notices',
            Sales: 'Out of stock/Sold out/Resale notices',
            Service: 'Affiliate service notices',
            Product: 'Product notices',
            Notice: 'Member notices',
            Next: 'See more announcements',
            Comment: 'There are 10 recent announcements. Click the button below to view more announcements.',
            SalesMore: 'See more notices for out of stock/sold out/resale',
            ProductMore: 'See more product announcements',
            ServiceMore: 'View more notices on affiliate service',
            NotFound: 'There are no announcements yet. Click the button below to see frequently asked questions from other members. [View frequently asked questions]',
            FAQ: 'View frequently asked questions',

        }
    },
};
